import { Alert } from "antd";
import { SurveyPage, SurveyElementBase } from "survey-react-ui";
import "../styling/page-admin.css";

export class PageAdmin extends SurveyPage {
  protected renderTitle() {
    return <></>;
  }

  protected renderDescription() {
    return this.page.description ? (
      <Alert
        description={SurveyElementBase.renderLocString(
          this.page.locDescription,
        )}
        type="info"
        style={{ marginBottom: 20 }}
      />
    ) : null;
  }
}
